export default "__VITE_ASSET__C4DWNR3D__"